var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#EE524F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.8723 99.7308H50.0488V81.8632V63.9956H73.8723H97.6958V81.8632V99.7308H73.8723Z",
    fill: "#B61B1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0357 180.871H50.2122V163.004V145.136H74.0357H97.8592V163.004V180.871H74.0357Z",
    fill: "#B61B1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M181.696 99.7308H157.872V81.8632V63.9956H181.696H205.519V81.8632V99.7308H181.696Z",
    fill: "#B61B1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167.205 206.66H153.019V201.34V196.021H160.112H167.205V187.154L168.028 177.48H160.935H153.842L153.019 157.009V135.73H181.391H209.763V157.009L210.586 177.48H203.493H196.4L195.577 185.381V192.474H188.484H181.391V199.567V206.66L167.205 206.66Z",
    fill: "#B61B1B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M166.451 203.313H151.019V197.527V191.74H158.735H166.451V182.095V172.451H158.735H151.019V149.304V126.157H181.882H212.745V149.304V172.451H205.029H197.313V180.166V187.882H189.598H181.882V195.598V203.313L166.451 203.313ZM73.8627 176.309H43V151.233V126.157H73.8627H104.725V151.233V176.309H73.8627ZM73.8627 95.294H43V72.147V49H73.8627H104.725V72.147V95.294H73.8627ZM181.882 95.294H151.019V72.147V49H181.882H212.745V72.147V95.294H181.882Z",
    fill: "#414141"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForth);
export default __webpack_public_path__ + "static/media/Forth.f3ca05488e4b6fa8b6667e91cd65be3f.svg";
export { ForwardRef as ReactComponent };